<template>
  <div class="row">
    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-12 pl-0">
      <div
        v-for="item in tabs"
        :key="item.step"
        class="d-flex align-items-center"
      >
        <button
          @click="handleStep(item.step)"
          :outlined="step != item.step"
          :class="[
            step == item.step && 'btn-nav-menu',
            step != item.step && 'btn-nav-menu1',
          ]"
        >
          <strong>{{ item.title }}</strong>
        </button>
        <div
          :class="[
            step == item.step && 'triangulo-para-direita',
            step != item.step && 'triangulo-none',
          ]"
        ></div>
      </div>
    </div>
    <div class="col-xl-10 col-lg-10 col-md-9 col-sm-12 col-12 pt-0 pl-0 pr-0">
      <slot :name="step"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "LeftTabs",

  props: {
    menu: { type: String, required: true },
    tabs: {
      type: Array,
      required: true,
      validator: function (value) {
        let valid = true;
        if (value.length === 0) valid = false;
        else if (
          value.some((tab) => {
            typeof tab.title !== "string" || typeof tab.step !== "string";
          })
        )
          valid = false;
        return valid;
      },
    },
  },

  data() {
    return {
      step: null,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    handleStep(step) {
      let newMenu = step;
      let query = { ...this.$router.currentRoute.query };

      if (query[this.menu] != newMenu) {
        query[this.menu] = newMenu;
        this.$router.replace({ query });
      }

      this.step = step;
    },

    retrieve() {
      let query = { ...this.$router.currentRoute.query };

      if (query[this.menu]) {
        let step = query[this.menu];

        if (this.tabs.some((tab) => tab.step === step)) this.step = step;
        else this.handleStep(this.tabs[0].step);
      } else {
        query[this.menu] = this.tabs[0].step;
        this.$router.replace({ query });
      }
    },
  },
};
</script>

<style>
</style>